import React from 'react';

export const EditIcon = ({ color } : { color: string }) => {

    return (
        <svg
            width={25}
            height={25}
            viewBox="0 0 194.000000 194.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g
                transform="translate(0.000000,194.000000) scale(0.100000,-0.100000)"
                fill={color}
                stroke="none"
            >
                <path
                    d="M105 1921 c-48 -22 -69 -44 -90 -94 -12 -30 -15 -88 -15 -329 0 -263
    2 -297 19 -333 22 -49 48 -73 98 -91 49 -17 577 -20 638 -3 21 6 53 25 71 43
    18 18 37 50 43 71 17 61 14 589 -3 638 -18 50 -42 76 -91 98 -36 17 -70 19
    -335 19 -265 0 -299 -2 -335 -19z"
                />
                <path
                    d="M1165 1921 c-49 -22 -73 -48 -91 -98 -17 -49 -20 -577 -3 -638 14
    -50 64 -100 114 -114 61 -17 589 -14 638 3 50 18 76 42 98 91 17 36 19 70 19
    335 0 265 -2 299 -19 335 -22 48 -44 69 -94 90 -30 12 -88 15 -329 15 -263 0
    -297 -2 -333 -19z"
                />
                <path
                    d="M117 866 c-50 -18 -76 -42 -98 -91 -17 -36 -19 -70 -19 -333 0 -241
    3 -299 15 -329 21 -50 42 -72 90 -94 36 -17 70 -19 335 -19 265 0 299 2 335
    19 49 22 73 48 91 98 17 49 20 577 3 638 -14 50 -64 100 -114 114 -61 17 -589
    14 -638 -3z"
                />
                <path
                    d="M1175 865 c-49 -17 -90 -62 -104 -112 -17 -59 -14 -588 3 -636 18
    -50 42 -76 91 -98 36 -17 70 -19 333 -19 241 0 299 3 329 15 50 21 72 42 94
    90 17 36 19 70 19 335 0 265 -2 299 -19 335 -22 49 -48 73 -98 91 -56 19 -591
    19 -648 -1z"
                />
            </g>
        </svg>
    );
};
